<template>
<el-drawer :title="drawer.title" :visible.sync="drawer.visible" size="30%">
    <el-form :model="ruleForm" :rules="rules" ref="platformRuleForm" labelPosition="top" class="ruleForm">
        <el-form-item label="平台名称" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
            <el-input v-model="ruleForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="上/下选" prop="is_valid">
            <el-select v-model="ruleForm.is_valid" placeholder="上/下线">
                <el-option label="上线" value="1"></el-option>
                <el-option label="下线" value="0"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submitForm('platformRuleForm')">保存</el-button>
            <el-button @click="resetForm('platformRuleForm')">重置</el-button>
        </el-form-item>
    </el-form>
</el-drawer>
</template>

<script>
import '../css/common.css'

export default {
    data() {
        return {
            drawer: {
                title: '',
                visible: false
            },
            ruleForm: {
                id: 0,
                title: '',
                sort: 0,
                is_valid: '1'
            },
            rules: {
                title: [{
                        required: true,
                        message: '请输入平台名称',
                        trigger: 'blur'
                    },
                    {
                        min: 3,
                        max: 100,
                        message: '长度在 3 到 100 个字符',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    created() {

    },
    methods: {
        showDrawer(options) {
            let that = this;
            if (options == '') {
                this.drawer.title = '添加推广平台';
            } else {
                this.drawer.title = '编辑推广平台';
            }
            this.drawer.visible = true;
            if (options != '') {
                let url = '/api/promoter.platform/read';
                this.$post(url, options).then(function (response) {
                    if (response.code == '200') {
                        that.ruleForm = response.data.row;
                        that.ruleForm.is_valid = that.ruleForm.is_valid + '';
                    } else {
                        this.$message(response.msg);
                    }
                });
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let that = this;
                    let url = '';
                    if (this.ruleForm.id == '') {
                        url = '/api/promoter.platform/create';
                    } else {
                        url = '/api/promoter.platform/save';
                    }
                    this.$post(url, this.ruleForm).then(function (response) {
                        if (response.code == '200') {
                            that.drawer.visible = false;
                            that.resetForm(formName);
                            // that.$parent.doSearch();
                            that.$emit("getTableData");
                        } else {
                            that.$message(response.msg);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
}
</script>
